export default "__VITE_ASSET__CBBnqdUQ__"